module.exports = __webpack_public_path__ + "static/media/app_banco24horas.9d6c1c84.jpg";